import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import initPlugins from './plugins'
import $ from 'jquery'
import Vuelidate from 'vuelidate'
import VueProgressBar from 'vue-progressbar'
import settings from './settings'

import Tooltip from '@/components/Tooltip'
Vue.component('v-tooltip', Tooltip)

Vue.config.productionTip = false

// Layouts
import Default from './layouts/Default.vue'
import Blank from './layouts/Blank.vue'
import Cabinet from './layouts/Cabinet.vue'
import SubdomainBrand from './layouts/SubdomainBrand.vue'

Vue.component('default-layout', Default)
Vue.component('blank-layout', Blank)
Vue.component('cabinet-layout', Cabinet)
Vue.component('subdomain-brand-layout', SubdomainBrand)

import LazyImage from '@/components/LazyImage'
Vue.component('lazy-image', LazyImage)

window.$ = $
window.jQuery = $

Vue.use(Vuelidate)

Vue.use(VueProgressBar, {
    color: '#2C63DC',
    failedColor: 'red',
    height: '2px',
    position: 'fixed'
})

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

Vue.prototype.$APP_URL = settings.APP_URL

const app = {
    store,
    router,
    render: h => h(App)
}

initPlugins(app)

export default new Vue(app).$mount('#app')
